export default __webpack_public_path__ + "static/media/settings.6bb904a1.svg";